export default __webpack_public_path__ + "static/media/CurriculumVideo.8336ed49.svg";